export default __webpack_public_path__ + "150a28f8e040b3f9e7027d936f0e7365.png";